<template lang="pug">
  #task.custom-container
    .section-title Tareas
    b-breadcrumb.breadcrumb(:items="breadcrumbs")
    ListTasks()
</template>
<script>
import ListTasks from '../components/task/ListTasks';
export default {
  data(){
    return{
      breadcrumbs: [
        {
          text: 'Inicio',
          to: { name: 'Home' }
        },
        {
          text: 'Tareas',
          active:true
        },
      ]
    }
  },
  components: {
    ListTasks
  }
}
</script>
